import React from "react";
import { Bar, Bubble, Doughnut, Line, Pie, PolarArea, Radar, Scatter } from "react-chartjs-2";
import zoom from 'chartjs-plugin-zoom'
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation } from "../../utils/useful";



class ChartWidget extends React.Component {
    state = {
        show: true,

        // data: [],
        data: {
            labels: ["Jan", "Fed", "Mar", "Apr", "May", 'Jun', "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

            datasets: [
                {
                    label: 'Humidity',
                    data: [5, 4, 0.5, 5, 4, 0.5],
                    fill: false,
                    backgroundColor: 'rgb(169, 212, 125)',
                    borderColor: 'rgba(169, 212, 125)',
                },
                {
                    label: 'Temperature',
                    data: [1, 2, 4, 1, 2, 4],
                    fill: false,
                    backgroundColor: 'rgb(237, 196, 86)',
                    borderColor: 'rgba(237, 196, 86)',
                },

            ]
        },

        thing: {},
        // topicId: nanoid(10),

        timeChartOptions: {
            bezierCurve: false,

            zoom: {
                enabled: true,
                // drag:true,
                mode: 'xy',
                overScaleMode: 'y',
                modifierKey: 'shift',

                wheel: {
                    enabled: false,
                    modifierKey: 'shift',

                },


                drag: {
                    enabled: true,
                    modifierKey: 'shift',

                },

                pinch: {
                    enabled: true,
                    modifierKey: 'shift',

                },


            },




            scales: {
                // xAxes: [

                //     {
                //         gridLines: {
                //             color: 'transparent',


                //         },
                //         ticks: {
                //             beginAtZero: true,
                //             fontColor: '#afafaf',
                //             fontSize: 12,
                //         }
                //     },
                // ],
                // yAxes: [
                //     {
                //         gridLines: {
                //             color: "#eeeeeeFF"

                //         },
                //         ticks: {
                //             beginAtZero: true,
                //             fontColor: '#afafaf',
                //             fontSize: 12,
                //         }
                //     },
                // ],


            }
        },

    }

    options = {
        scales: {
            yAxes: [
                {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',

                },
            ],
        },
    }

    colors = [
        { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
        { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
        { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
    ]



    componentDidMount() {
        window.addEventListener('resize', this.getSize)
        this.getSize()
        // Chart.register(zoom)
        // Bar.register(zoom)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }


    render() {
        return (
            <div className="dashboard-widgets h-100 pb-2">
                <div className="d-flex justify-content-between pt-3">
                    <div className="d-flex  px-3 ">
                        <div className="text-semibold">
                            <p>{checkTranslation(this.props.data?.title)}</p>
                        </div>
                    </div>
                    <div className="px-3" >
                        {/* <div style={{ background: '#fff', padding: '0 6px 2% 6px' }}>

                                <p style={{}}>${this.props.praise}&nbsp;Urpaid Last 365 days</p>
                            </div> */}
                        <div className="mb-2">
                            <div className=" pld-1 ">
                                <div className=" mb-1 ">
                                    <p style={{ fontSize: 25, fontWeight: '600' }}>$6,953</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: 12, color: '#777', fontWeight: '600' }}>LAST MONTH</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="px-2">
                    {(this.props.chartType == 'line' || !this.props.chartType) && (

                        <Line
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {this.props.chartType == 'pie' && (

                        <Pie
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {this.props.chartType == 'doughnut' && (

                        <Doughnut
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {this.props.chartType == 'scatter' && (

                        <Scatter
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {this.props.chartType == 'bar' && (

                        <Bar
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {/* {this.props.chartType == 'horizontalBar' && (

                        <HorizontalBar
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )} */}

                    {this.props.chartType == 'radar' && (

                        <Radar
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {this.props.chartType == 'polar' && (

                        <PolarArea
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}

                    {this.props.chartType == 'bubble' && (

                        <Bubble
                            data={this.state.data}
                            height={this.props.height}
                            ref={el => this.chart = el}
                        />

                    )}
                </div>
            </div>
        )
    }
}

export default ChartWidget;

